// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"45a72e28","977":"59ef41fe"}[chunkId] + ".chunk.js";
};